import React, { useState } from "react";
import Giveaway from "./GiveAway/GiveAway";
import Donation from "./Donation/Donation";
import UserDonation from "./UserDonation/UserDonation";
import BiddingPanel from "./BiddingPanel/BiddingPanel";
import UserBidding from "./UserBidding/UserBidding";
import GiftCard from "./GiftCard/GiftCards/GiftCard";
import GiftCardRequests from "./GiftCard/GiftCardRequests/GiftCardRequests";
import GiftCardRequestComplete from "./GiftCard/GiftCardComplete/GiftCardComplete";
import GiftCardRequestCancelled from "./GiftCard/GiftCardCancelled/GiftCardCancelled";
import AgencyTabURL from "./AgencyTabURL";
import RedeemMethodsUrlTab from "./RedeemMethodsUrlTab";
import TransactionUrlTab from "./TransactionUrlTab";



const Redeem = () => {
  const [activeComponent, setActiveComponent] = useState("Quick Poll");
  // Array with tab names and corresponding components
  const tabs = [
    { name: "Quick Poll", component: <Giveaway /> },
    { name: "Agency", component: <AgencyTabURL /> },
    { name: "Redeem Methods", component: <RedeemMethodsUrlTab /> },
    
    { name: "Transactions", component: <TransactionUrlTab /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)] z-20">
        <h1 className="text-xl m-4 font-semibold">Redeem</h1>
        <div className="flex space-x-2 mb-6 max-w-100 flex-wrap gap-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-3 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default Redeem;
